import { useRaffleById } from '@/app/hooks/useRaffles'
import { Button } from '@/view/components/ui/button'
import { Spinner } from '@/view/components/ui/spinner'
import { ChevronLeft } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'
import { RaffleForm } from './components/RaffleForm'

export const ManageRaffleDetailPage = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const isNew = id === 'new'

  const handleBack = () => {
    navigate('/sorteios/gerenciar')
  }

  const handleViewMode = () => {
    navigate(`/sorteios/gerenciar/view/${id}`)
  }

  const { data: raffle, isLoading, isError } = useRaffleById(id!, isNew)

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    )
  }

  if (isError) {
    return <div>Erro ao buscar sorteio</div>
  }

  if (!raffle && !isNew) {
    return <div>Sorteio não encontrado</div>
  }

  return (
    <div className="px-2 sm:px-0">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            className="rounded-full"
            onClick={handleBack}
          >
            <ChevronLeft size={20} className="sm:mr-2 sm:size-6" />
          </Button>
          <h1 className="text-lg font-semibold sm:text-2xl">
            {isNew ? 'Novo sorteio' : raffle?.name}
          </h1>
        </div>
        {!isNew && (
          <Button
            variant="outline"
            className="w-full rounded-full sm:w-auto"
            onClick={handleViewMode}
          >
            Visualizar
          </Button>
        )}
      </div>
      <RaffleForm raffle={isNew ? undefined : raffle} />
    </div>
  )
}
